import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IncludeFavoritesPipe } from '@common/menu/pipes/include-favorites.pipe';
import { NavigationFilterPipe } from '@common/menu/pipes/navigation-filter.pipe';
import { GroupByPipeModule } from '@common/pipes/group-pipe.module.ts/group-by-pipe.module';
import { IncludesPipeModule } from '@common/pipes/includes/includes-pipe.module';
import { EditShopifyLinkModalComponent } from './edit-shopify-link-modal/edit-shopify-link-modal.component';
import { MenuComponent } from './menu.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';

@NgModule({
  declarations: [
    MenuComponent,
    SidebarMenuComponent,
    NavigationFilterPipe,
    IncludeFavoritesPipe,
    EditShopifyLinkModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatIconModule,
    MatExpansionModule,
    MatTooltipModule,
    MatListModule,
    MatInputModule,
    MatDialogModule,
    IncludesPipeModule,
    MatSnackBarModule,
    GroupByPipeModule
  ],
  exports: [
    MenuComponent,
    SidebarMenuComponent
  ]
})
export class MenuModule { }
